import React, { CSSProperties, PropsWithChildren } from "react";
import styled from "styled-components";
import AntSpin, { SpinSize } from "antd/es/spin";
import Overlay, { OverlayProps } from "common/Overlays/Overlay";

export interface LoadingSpinnerOverlayProps extends OverlayProps {
  spinnerSize?: SpinSize;
  spinnerStyle?: CSSProperties;
  spinnerColor?: string;
}

const LoadingSpinnerOverlay: React.FunctionComponent<
  PropsWithChildren<LoadingSpinnerOverlayProps>
> = ({ children, spinnerSize, spinnerStyle, spinnerColor, ...props }) => {
  const spinner = (
    <Spin size={spinnerSize} style={spinnerStyle} $color={spinnerColor} />
  );

  return (
    <Overlay overlayContent={spinner} {...props}>
      {children}
    </Overlay>
  );
};

export default LoadingSpinnerOverlay;

const Spin = styled(AntSpin)<{ $color?: string }>`
  .ant-spin-dot-item {
    background: ${(p) => p.$color ?? p.theme.colors.primaryBlue};
  }
`;
